import { render, staticRenderFns } from "./SummaryPlate.vue?vue&type=template&id=1986c004&scoped=true&"
import script from "./SummaryPlate.vue?vue&type=script&lang=js&"
export * from "./SummaryPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986c004",
  null
  
)

export default component.exports